export default function resetStorageBookingValues() {
  window.localStorage.removeItem('current_booking_price');
  window.localStorage.removeItem('current_booking_id');
  window.localStorage.removeItem('amount');
  window.localStorage.removeItem('booking-space-id');
  window.localStorage.removeItem('services_picked');
  window.localStorage.removeItem('services_details');
  window.localStorage.removeItem('disposition');
  window.localStorage.removeItem('booking_use_discount_code');
  window.localStorage.removeItem('booking_discount_code');
  window.localStorage.removeItem('booking_discount_code_id');
  window.localStorage.removeItem('booking_discount_code_discounted');
}
